// angular import
import { OnInit, Component, inject } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, ActivatedRoute, RouterOutlet } from '@angular/router';


// Angular material
import { MatProgressBar } from '@angular/material/progress-bar';
import { Header } from './@theme/layouts/header/header';
import { FooterComponent } from './@theme/layouts/footer/footer.component';
import { LoadingOverlayComponent } from './pages/loading-overlay/loading-overlay';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatProgressBar, Header, FooterComponent, LoadingOverlayComponent, BreadcrumbComponent ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  activeRoute = inject(ActivatedRoute);
  private navigatorLanguages = ['fr', 'ar'];

  // public props
  isSpinnerVisible = true;

  ngOnInit() {
    // Use ngOnInit instead of ngAfterViewInit
    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          setTimeout(() => {
            this.isSpinnerVisible = true;
          });
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          setTimeout(() => {
            this.isSpinnerVisible = false;
          });
        }
      },
      () => {
        setTimeout(() => {
          this.isSpinnerVisible = false;
        });
      }
    );
  }
  // initApplicationLanguage(): void {
  //   const navigatorLanguage = navigator.language.split('-')[0];
  //   const language = this.navigatorLanguages.indexOf(navigatorLanguage) > -1 ? navigatorLanguage : 'ar';
  //   localStorage.setItem('language', language);
  //   this.translateService.use(language.toLowerCase());
  // }
}
